/** 教务中心 - 学校身份路由 **/

// 学校平台轮播图管理-列表
const CarouselIndex = () => import('@pv/eduCenter/school/carousel/index');

// 学校平台轮播图管理-详情
const CarouselDetails = () => import('@pv/eduCenter/school/carousel/details');

// 评价管理
const EvaluationIndex = () => import('@pv/eduCenter/school/evaluation/Index');

// 消息管理
const MessageIndex = () => import('@pv/eduCenter/school/message/Index');

// 教师考勤
const Attendance = () => import('@pv/eduCenter/school/attendance/Index');
// 教师考勤汇总(按月)
const AttendanceCollect = () =>
  import('@pv/eduCenter/school/attendance/Collect');
// 教师考勤修改
const AttendanceEdit = () => import('@pv/eduCenter/school/attendance/Edit');

// 教师考勤汇总
const AttendanceCollectAll = () =>
  import('@pv/eduCenter/school/attendance/CollectAll');

export default [
  // 轮播图管理
  {
    path: '/eduCenter/schoolCarousel/index',
    name: 'eduCenter_schoolCarousel_index',
    meta: {
      title: '学校轮播图',
      activePath: '/eduCenter/schoolCarousel/index',
      breadcrumb: '教务中心-轮播图管理-学校轮播图'
    },
    component: CarouselIndex
  },
  // 轮播图详情-编辑
  {
    path: '/eduCenter/schoolCarousel/carouselDetails',
    name: 'eduCenter_schoolCarousel_carouselDetails',
    meta: {
      title: '轮播图管理',
      activePath: '/eduCenter/schoolCarousel/index'
    },
    component: CarouselDetails
  },
  // 评价管理
  {
    path: '/eduCenter/schoolEvaluation/Index',
    name: 'eduCenter_schoolEvaluation_Index',
    meta: { title: '评价管理' },
    component: EvaluationIndex
  },
  // 消息管理
  {
    path: '/eduCenter/schoolMessage/Index',
    name: 'eduCenter_schoolMessage_Index',
    meta: { title: '消息管理' },
    component: MessageIndex
  },
  // 教师考勤
  {
    path: '/eduCenter/schoolAttendance/index',
    name: 'eduCenter_schoolAttendance_index',
    meta: {
      title: '教师考勤',
      activePath: '/eduCenter/schoolAttendance/index',
      breadcrumb: '教务中心-教师考勤-教师考勤明细',
      showChangeSchool: true
    },
    component: Attendance
  },
  {
    path: '/eduCenter/schoolAttendance/collect',
    name: 'eduCenter_schoolAttendance_collect',
    meta: {
      title: '教师考勤汇总(按月)',
      activePath: '/eduCenter/schoolAttendance/collect',
      breadcrumb: '教务中心-教师考勤-教师考勤汇总(按月)',
      showChangeSchool: true
    },
    component: AttendanceCollect
  },
  {
    path: '/eduCenter/schoolAttendance/edit',
    name: 'eduCenter_schoolAttendance_edit',
    meta: {
      title: '教师考勤',
      activePath: '/eduCenter/schoolAttendance/collect',
      breadcrumb: '教务中心-教师考勤-教师考勤修改',
      showChangeSchool: true
    },
    component: AttendanceEdit
  },
  // 教师考勤
  {
    path: '/eduCenter/schoolAttendance/collectedu',
    name: 'eduCenter_schoolAttendance_collectedu',
    meta: {
      title: '教师考勤汇总(按月)',
      activePath: '/eduCenter/schoolAttendance/collectedu',
      breadcrumb: '教务中心-教师考勤-教师考勤汇总(按月)'
    },
    component: AttendanceCollect
  },
  {
    path: '/eduCenter/schoolAttendance/collectAll',
    name: 'eduCenter_schoolAttendance_collectAll',
    meta: {
      title: '教师考勤汇总',
      activePath: '/eduCenter/schoolAttendance/collectAll',
      breadcrumb: '教务中心-教师考勤-教师考勤汇总',
      showChangeSchool: true
    },
    component: AttendanceCollectAll
  }
];
